import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HappyPayTopUp } from '../interfaces/happy-pay.interface';

const apiUrl = environment.apiUrl + 'user/happy_pay_top_up';
const enumApiUrl = environment.apiUrl + 'guest/enum';

@Injectable({
  providedIn: 'root',
})
export class HappyPayTopUpService {
  happyPayTopUpMethods: BehaviorSubject<any> = new BehaviorSubject(null);
  newHPTopupState: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private messageService: MessageService,
    private router: Router
  ) {}

  setNewHpTopupState(value: any) {
    this.newHPTopupState.next(value);
  }

  getNewHPTopupState() {
    return this.newHPTopupState.asObservable();
  }

  private fetchHappyPayTopUpMethods() {
    return this.http
      .get(enumApiUrl + '/happy_pay_top_up_method')
      .pipe(
        map((res: any) => {
          const methods = res.data;
          return methods;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getHappyPayTopUpMethods() {
    if (!this.happyPayTopUpMethods.value) {
      this.fetchHappyPayTopUpMethods().subscribe((data) => {
        this.happyPayTopUpMethods.next(data);
        return data;
      });
    }
    return this.happyPayTopUpMethods.asObservable();
  }

  getHappyPayTopUps(
    itemPerPage: number,
    currentPage: number = 1,
    dateFilter: any = null
  ) {
    const body = {
      item_per_page: itemPerPage,
      current_page: currentPage,
      start_date: dateFilter ? dateFilter.start : null,
      end_date: dateFilter ? dateFilter.end : null,
      sorts: [{ field: 'created_at', direction: 'DESC' }],
    };
    return this.http
      .post(apiUrl + '/search', body)
      .pipe(
        map((res: any) => {
          let topUps: HappyPayTopUp[] = res.data['happypay_topups'];
          topUps.forEach((topUp) => {
            if (topUp.created_at)
              topUp.formatted_created_at =
                this.datePipe.transform(
                  new Date(topUp.created_at),
                  'dd MMM yyyy, HH:mm'
                ) || '';
            if (topUp.updated_at)
              topUp.formatted_update_at =
                this.datePipe.transform(
                  new Date(topUp.updated_at),
                  'dd MMM yyyy, HH:mm'
                ) || '';
          });
          return { totalItems: res.data['total_items'], topUps: topUps };
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getHappyPayTopUp(id: any) {
    return this.http
      .get(apiUrl + '/' + id)
      .pipe(
        map((res: any) => {
          let topUp: HappyPayTopUp = res.data;
          if (topUp.created_at)
            topUp.formatted_created_at =
              this.datePipe.transform(
                new Date(topUp.created_at),
                'dd MMM yyyy, HH:mm'
              ) || '';
          if (topUp.updated_at)
            topUp.formatted_update_at =
              this.datePipe.transform(
                new Date(topUp.updated_at),
                'dd MMM yyyy, HH:mm'
              ) || '';
          return topUp;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  addHappyPayTopUp(newTopUp: HappyPayTopUp) {
    return this.http.post(apiUrl, newTopUp).pipe(
      map((res: any) => {
        let resData: any = res.data;
        const paymentMethod = Number(resData.payment_method);
        if (paymentMethod == 0) {
          this.router.navigate([
            './payment/credit-card',
            {
              tXid: resData.tXid,
              happyPayTopUpId: resData.happy_pay_top_up_id,
            },
          ]);
        } else if (paymentMethod >= 1 && paymentMethod <= 11) {
          this.router.navigate([
            './payment/virtual-account',
            {
              paymentMethod: resData.payment_method,
              vaccNo: resData.vacc_no,
              happyPayTopUpId: resData.happy_pay_top_up_id,
            },
          ]);
        }
        this.handleSuccess('Berhasil melakukan top up happy pay');
        return res;
      })
    );
  }

  private handleSuccess(message: any) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }
}
